/**
 * MediaCitationsUserEvents
 * Registry of events for the Press & Citations page
 */
export enum MediaCitationsUserEvents {
    ClickCitationCard = "Media Citations - Click Citation Card",
    ClickCitationListRow = "Media Citations - Click Citation List Row",
    ChangePublisherFilter = "Media Citations - Change Publisher Filter",
    ChangeTypeFilter = "Media Citations - Change Type Filter",
    ChangeSort = "Media Citations - Change Sort",
    ClearFilters = "Media Citations - Clear Filters",
}
